import { render, staticRenderFns } from "./ResetPasswordView.vue?vue&type=template&id=19f84356&scoped=true"
import script from "./ResetPasswordView.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordView.vue?vue&type=script&lang=ts"
import style0 from "./ResetPasswordView.vue?vue&type=style&index=0&id=19f84356&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f84356",
  null
  
)

export default component.exports